<template>
  <span>{{ displayValue < 0 ? 0 : displayValue }}</span>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'

const props = defineProps({
  value: { type: Number, required: true },
  duration: { type: Number, default: 800 },
  formatter: { type: Function, default: v => v }
})

const displayValue = ref(props.formatter(0))
let animationFrame = null

function animateNumber(to, duration) {
  cancelAnimationFrame(animationFrame)
  const startTime = performance.now()
  const target = Math.max(0, to) // 确保目标值不为负数
  
  function step(now) {
    const progress = Math.min((now - startTime) / duration, 1)
    const current = target * progress
    const formattedValue = props.formatter(Math.max(0, Math.round(current))) // 确保显示值不为负数
    displayValue.value = formattedValue
    
    if (progress < 1) {
      animationFrame = requestAnimationFrame(step)
    } else {
      displayValue.value = props.formatter(target) // 最终值也不为负数
    }
  }
  
  animationFrame = requestAnimationFrame(step)
}

onMounted(() => {
  animateNumber(props.value, props.duration)
})

watch(
  () => props.value,
  (newVal) => {
    animateNumber(newVal, props.duration)
  }
)
</script>